// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"80a6f429","453":"9de5a8d9","498":"ab8b9fdf","732":"26a4aea6","977":"403db18d"}[chunkId] + ".chunk.js";
};